const ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const escapeHtml = (value = '') => `${value}`.replace(/[&<>"']/g, (char) => ENTITIES[char]);
